import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { withCoreComponent } from 'core/hocs';
import { FormattedTag, ProducerGames as ProducerGamesCore } from 'core/components';
import { isEmptyOrNil } from 'core/helpers';
import { Main } from 'components/main/main';
import { GameCard } from 'components/game-card/game-card';
import { HeadHelmet } from 'components/head-helmet/head-helmet';

import { PAGE_NAMES } from '../../constants';

export const ProducerGamesUI = ({
  isUserLoggedIn,
  toggleFavoriteGame,
  openGame,
  games,
  producer,
  slugProducer,
  isShowMoreAvailable,
  showMore,
}) => (
  <Main>
    <HeadHelmet
      page={PAGE_NAMES.PROVIDER}
      values={{
        provider: producer,
        providerSlug: slugProducer,
      }}
    />

    <div className="h1 mt-5 mt-md-8_5 mb-sm-5 mb-md-6 provider-title text-center letter-spacing-extra">{producer}</div>
    <div className="provider-games-list">
      {!isEmptyOrNil(games) && games.map((game, idx) => (
        <GameCard
          // eslint-disable-next-line react/no-array-index-key
          key={`${game.gameId}-${game.producer}-${idx}`}
          {...game}
          isUserLoggedIn={isUserLoggedIn}
          toggleFavoriteGame={toggleFavoriteGame}
          openGame={openGame}
          withJackpotAmount
        />
      ))}
    </div>

    {isShowMoreAvailable && (
      <FormattedTag
        tag={Button}
        id="show-more"
        color="gray-10"
        className="provider-btn-show-more d-block mx-auto mt-2_25"
        onClick={showMore}
        outline
      />
    )}

  </Main>
);

ProducerGamesUI.propTypes = {
  games: PropTypes.arrayOf(PropTypes.shape()),
  openGame: PropTypes.func.isRequired,
  toggleFavoriteGame: PropTypes.func.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  producer: PropTypes.string.isRequired,
  slugProducer: PropTypes.string.isRequired,
  isShowMoreAvailable: PropTypes.bool.isRequired,
  showMore: PropTypes.func.isRequired,
};

ProducerGamesUI.defaultProps = {
  games: [],
};

export const ProducerGames = withCoreComponent(ProducerGamesCore, ProducerGamesUI);
